export default "__VITE_ASSET__ydO1QVc2__"